//#region Imports

import { Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { hasKeycode, hasModifierKey, KeyNames, KEYS, ModifierKey } from './functions';
import { MatchConfig } from './match.config';

//#endregion

/**
 * A classe que representa o serviço que lida com os KeyBinds da aplicação
 *
 * Referência: https://www.joshbritz.co/posts/create-a-keybinding-service-in-angular/
 */
@Injectable({
  providedIn: 'root',
})
export class KeybindService {

  //#region Public Methods

  public match(
    matchKey: KeyNames,
    matchModifiers: ModifierKey[] = [],
    options?: MatchConfig,
  ): Observable<KeyboardEvent> {
    const { listenOn } = new MatchConfig(options);
    return new Observable((observer) => {
      const listener$ = fromEvent(listenOn, 'keydown');
      listener$.subscribe((event: KeyboardEvent) => {
        if (!hasKeycode(event, [KEYS[matchKey]]))
          return;

        if (!matchModifiers.length || hasModifierKey(event, ...matchModifiers)) {
          observer.next(event);
        }
      });
    });
  }

  //#endregion

}
